<nz-page-header nzTitle="Upload Details" nzSubtitle="View uploaded bank deposit">
	<nz-page-header-extra>
		<button nz-button nzType="default" routerLink="/insurance/upload-payments">
			<i nz-icon nzType="arrow-left"></i> Back
		</button>
	</nz-page-header-extra>
</nz-page-header>

<nz-spin [nzSpinning]="loading">
	<!-- <div *ngIf="upload" class="row">
		<div class="col-12 mb-3">
			<div class="alert alert-info d-flex justify-content-between align-items-center" *ngIf="processing != true && !upload.processStartedAt">
				<span><strong>Pending</strong> — This upload has not been processed yet.</span>
				<button nz-button nzType="primary" (click)="doProcess()">Process</button>
			</div>
			<div class="alert alert-warning" *ngIf="processing == true || (upload.processStartedAt && !upload.processCompletedAt)">
				<strong>Processing</strong> — This upload is currently being processed.
			</div>
			<div class="alert alert-success" *ngIf="processing != true && upload.processCompletedAt">
				<strong>Completed</strong> — This upload has been processed successfully.
			</div>
		</div>
	</div> -->
	<div *ngIf="upload" class="row">
		<div class="col-12 mb-3">
			<nz-card nzTitle="Upload Summary">
				<div class="row">
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Upload ID</label>
						<span>{{ upload.id }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Created At</label>
						<span>{{ upload.createdAt | date:'medium' }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Agent</label>
						<span>{{ upload.agent.username ?? '-' }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Total Records</label>
						<span>{{ upload.countOfRecords }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Failed</label>
						<nz-tag [nzColor]="'red'" *ngIf="upload.countOfFailedRecords != null">
							{{ upload.countOfFailedRecords }}</nz-tag>
						<span *ngIf="upload.countOfFailedRecords == null">-</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Invalid</label>
						<nz-tag [nzColor]="'orange'" *ngIf="upload.countOfInvalidRecords != null">
							{{ upload.countOfInvalidRecords }}</nz-tag>
						<span *ngIf="upload.countOfInvalidRecords == null">-</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Total Deposit Amount</label>
						<span>{{ upload.amount | number:'1.2-2' }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Status</label>
						<nz-tag *ngIf="!upload.processStartedAt" nzColor="default">Pending</nz-tag>
						<nz-tag *ngIf="upload.processStartedAt && !upload.processCompletedAt" nzColor="processing">
							Processing</nz-tag>
						<nz-tag *ngIf="upload.processCompletedAt" nzColor="success">Completed</nz-tag>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Process Started At</label>
						<span>{{ upload.processStartedAt ? (upload.processStartedAt | date:'medium') : '-' }}</span>
					</div>
					<div class="col-md-4 mb-2">
						<label class="text-muted d-block">Process Completed At</label>
						<span>{{ upload.processCompletedAt ? (upload.processCompletedAt | date:'medium') : '-' }}</span>
					</div>
				</div>
			</nz-card>
		</div>
	</div>
	<div class="row">
		<!-- Entries Table -->
		<div class="col-12">
			<nz-card nzTitle="Entries">
				<nz-table #entryTable [nzData]="upload.entries" [nzPageSize]="20" [nzShowSizeChanger]="true"
					nzSize="small">
					<thead>
						<tr>
							<th>#</th>
							<th>Deposited At</th>
							<th>From Account</th>
							<th>To Account</th>
							<th>Deposit Amount</th>
							<th>Allocated Amount</th>
							<th>Remaining Amount</th>
							<th>Reference</th>
							<th>Status</th>
							<th>Reason</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let entry of entryTable.data">
							<td>{{ entry.lineNumber }}</td>
							<td>{{ entry.depositDate | date }}</td>
							<td>{{ entry.fromBankAccountNumber ?? '-' }}</td>
							<td>{{ entry.toBankAccountNumber ?? '-' }}</td>
							<td>{{ entry.depositAmount | number:'1.2-2' }}</td>
							<td>{{ entry.allocatedAmount | number:'1.2-2' }}</td>
							<td>{{ (entry.depositAmount-entry.allocatedAmount) | number:'1.2-2' }}</td>
							<td>{{ entry.bankReference ?? '-' }}</td>
							<td>
								<nz-tag *ngIf="entry.status == 'Invalid'" [nzColor]="'red'">Invalid</nz-tag>
								<nz-tag *ngIf="entry.status == 'Failed'" [nzColor]="'red'">Failed</nz-tag>
								<nz-tag *ngIf="entry.status == 'Valid'" [nzColor]="'green'">Valid</nz-tag>
							</td>
							<td>{{ entry.failureReason ?? '-' }}</td>
						</tr>
					</tbody>
				</nz-table>
			</nz-card>
		</div>
	</div>
</nz-spin>
